function present(value) {
  return value !== null && value !== undefined && `${value}` !== "";
}

export function eventDetailUrl(event) {
  if (!present(event?.id)) {
    return "";
  }

  const base = `/calendar/events/${encodeURIComponent(event.id)}`;

  if (present(event.occurrence_id)) {
    return `${base}?occurrence_id=${encodeURIComponent(event.occurrence_id)}`;
  }

  if (present(event.occurrence_key)) {
    return `${base}?occurrence_key=${encodeURIComponent(event.occurrence_key)}`;
  }

  return base;
}

export function eventDetailRequest(eventId, queryParams = {}) {
  const data = {};

  if (present(queryParams.occurrence_id)) {
    data.occurrence_id = queryParams.occurrence_id;
  }

  if (present(queryParams.occurrence_key)) {
    data.occurrence_key = queryParams.occurrence_key;
  }

  return {
    url: `/calendar/events/${encodeURIComponent(eventId)}.json`,
    // Discourse's ajax() distinguishes one argument from two. Passing an
    // explicit undefined second argument leaves its internal options object
    // undefined and throws before a request is sent, so this must always be a
    // real object even when there are no occurrence parameters.
    options: { data },
  };
}
